/**
 * Can this request be opened right now?
 *
 * AC35 says acknowledging works offline; AC11 says the document must be read
 * before confirming. Those combine into a rule the ticket does not state: a
 * request whose document was never cached cannot be signed offline, because
 * doing so would record that somebody read a document they demonstrably could
 * not see — into a record that can never be corrected.
 *
 * So an uncached request is shown but not openable while offline, with a
 * "Needs connection" badge, rather than being hidden (which would look like the
 * obligation had gone away).
 */
export function canOpenOffline(
  isOffline: boolean,
  hasCachedDocument: boolean,
): boolean {
  return !isOffline || hasCachedDocument;
}

/**
 * Can it be SIGNED right now? Stricter than opening: an already-signed request
 * is not signable again, and offline signing needs the document present.
 */
export function canSignOffline(
  isOffline: boolean,
  hasCachedDocument: boolean,
  alreadySigned: boolean,
): boolean {
  if (alreadySigned) {
    return false;
  }
  return canOpenOffline(isOffline, hasCachedDocument);
}
